var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMynauiRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 5.33333C12.7387 3.214 10.4513 2 7.98533 2C4.866 2 2.302 4.368 2 7.4",
    stroke: "#002E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9928 5.59961H13.6395C13.6868 5.5997 13.7337 5.59045 13.7775 5.5724C13.8212 5.55434 13.861 5.52784 13.8945 5.4944C13.928 5.46097 13.9546 5.42125 13.9727 5.37753C13.9908 5.33381 14.0002 5.28694 14.0002 5.23961V2.59961M2.3335 10.6663C3.2615 12.7856 5.54883 13.9996 8.01483 13.9996C11.1342 13.9996 13.6982 11.6316 14.0002 8.59961",
    stroke: "#002E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00733 10.4004H2.36067C2.31333 10.4003 2.26645 10.4096 2.2227 10.4276C2.17894 10.4457 2.13918 10.4722 2.10568 10.5056C2.07218 10.539 2.0456 10.5788 2.02747 10.6225C2.00933 10.6662 2 10.7131 2 10.7604V13.4004",
    stroke: "#002E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMynauiRefresh);
export default __webpack_public_path__ + "static/media/mynaui_refresh.f2b09cf63689aec9cb4d001520360ccd.svg";
export { ForwardRef as ReactComponent };